import React, { useState } from "react";
import { Display } from "../Main/styles";
import CustomerFilter from "./CustomerFilter";
import dayjs from "dayjs";
import { RangePickerProps } from "rc-picker/es/RangePicker.d";
import { useFilterList } from "CRM/hooks/GetFilterList";
import CustomerTable from "./CustomerTable";
import { useIsMobile } from "../../components/IsMobile";
import { ReactComponent as FilterArrowBottom } from "../../../assets/FilterArrowBottom.svg";
import styled from "styled-components";

export const Customer = () => {
	const IsMobile = useIsMobile();
	const { filterList: pathList } = useFilterList("accessPath");
	const { filterList: resList } = useFilterList("responsibility", process.env.REACT_APP_API_URL!.includes("ccl") ? "customer" : null);
	const { filterList: teamList } = useFilterList("team");
	const { filterList: platformList } = useFilterList("platform");
	const [depositedAt, setDepositedAt] = useState<RangePickerProps<dayjs.Dayjs>["value"] | any>([null, null]);
	const [createdAt, setCreatedAt] = useState<RangePickerProps<dayjs.Dayjs>["value"] | any>([null, null]);
	const [assignedAt, setAssignedAt] = useState<RangePickerProps<dayjs.Dayjs>["value"] | any>([null, null]);
	const [updatedAt, setUpdatedAt] = useState<RangePickerProps<dayjs.Dayjs>["value"] | any>([null, null]);

	const [name, setName] = useState("");
	const [tel, setTel] = useState("");
	const [path, setPath] = useState("");
	const [respon, setRespon] = useState("");
	const [team, setTeam] = useState("");
	const [platform, setPlatform] = useState("");

	const [isFilter, setIsFilter] = useState(false);

	return (
		<Display IsMobile={IsMobile}>
			{IsMobile && (
				<div
					style={{
						backgroundColor: "white",
						width: "100%",
						height: 40,
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						zIndex: 2,
						boxShadow: "2px 2px 8px 2px #74747476",
						cursor: "pointer",
						marginBottom: !isFilter ? 20 : 0,
					}}
					onClick={() => setIsFilter(!isFilter)}
				>
					<div style={{ marginLeft: 15 }}>필터</div>
					{isFilter ? <RotatedSvg style={{ width: 45, height: 25 }} /> : <FilterArrowBottom style={{ width: 45, height: 25 }} />}
				</div>
			)}

			{IsMobile ? (
				<>
					{isFilter && (
						<CustomerFilter
							pathList={pathList}
							resList={resList}
							teamList={teamList}
							platformList={platformList}
							depositedAt={depositedAt}
							setDepositedAt={setDepositedAt}
							createdAt={createdAt}
							setCreatedAt={setCreatedAt}
							assignedAt={assignedAt}
							setAssignedAt={setAssignedAt}
							updatedAt={updatedAt}
							setUpdatedAt={setUpdatedAt}
							name={name}
							setName={setName}
							tel={tel}
							setTel={setTel}
							path={path}
							setPath={setPath}
							respon={respon}
							setRespon={setRespon}
							team={team}
							setTeam={setTeam}
							platform={platform}
							setPlatform={setPlatform}
						/>
					)}
				</>
			) : (
				<CustomerFilter
					pathList={pathList}
					resList={resList}
					teamList={teamList}
					platformList={platformList}
					depositedAt={depositedAt}
					setDepositedAt={setDepositedAt}
					createdAt={createdAt}
					setCreatedAt={setCreatedAt}
					assignedAt={assignedAt}
					setAssignedAt={setAssignedAt}
					updatedAt={updatedAt}
					setUpdatedAt={setUpdatedAt}
					name={name}
					setName={setName}
					tel={tel}
					setTel={setTel}
					path={path}
					setPath={setPath}
					respon={respon}
					setRespon={setRespon}
					team={team}
					setTeam={setTeam}
					platform={platform}
					setPlatform={setPlatform}
				/>
			)}

			<CustomerTable
				platformList={platformList}
				pathList={pathList}
				resList={resList}
				teamList={teamList}
				depositedAt={depositedAt}
				createdAt={createdAt}
				assignedAt={assignedAt}
				updatedAt={updatedAt}
				name={name}
				tel={tel}
				path={path}
				respon={respon}
				team={team}
				platform={platform}
			/>
		</Display>
	);
};

export default React.memo(Customer);

const RotatedSvg = styled(FilterArrowBottom)`
	transform: rotate(180deg);
	width: 45px;
	height: 25px;
`;
